module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-2200.7cb0299a.svg";